import React, { FC } from 'react'
import { Result } from 'antd'

export const FeatureDisabledResult: FC = () => {
  return (
    <div className='d-flex justify-content-center align-items-center h-100'>
      <Result
        status='403'
        title='Feature is disabled'
        subTitle={
          <div>
            <span>You do not have this feature enabled for your store</span>
            <br />
            <span>Please contact support-ca@blaze.me to enable it</span>
          </div>
        }
      />
    </div>
  )
}
